<template>
  <div
    id="parallaxscrolling"
    style="background-color: white"
    :style="{ 'pointer-events': !gesture ? 'auto' : 'none' }"
  >
    <img :src="isamnet" style="width: 100%" />
    <div id="ucf-content">
      <div id="main-wrapper">
        <div id="main-container">
          <div class="ucf-carousel-wrapper">
            <a class="arrow arrow-right" @click="shift()" v-if="len > 1"></a>
            <a
              class="arrow arrow-left"
              @click="invert_shift()"
              v-if="len > 1"
            ></a>

            <div class="ucf-carousel-container">
              <div
                :class="['item']"
                v-for="(image, index) in creative.images"
                :key="index"
                :style="{
                  transform: `translateX(${index * 100}%)`,
                }"
              >
                <a
                  v-if="image.material_type === CONSTANT.MATERIAL_TYPE.IMAGES"
                  :href="creative.landing_page"
                  target="_blank"
                >
                  <img :src="image.url" />
                </a>
                <div
                  class="overlay-iframe"
                  v-if="image.material_type === CONSTANT.MATERIAL_TYPE.HTML"
                  @click="openLandingPage"
                ></div>
                <iframe
                  :class="`h5-${index}`"
                  :src="image.url"
                  v-if="image.material_type === CONSTANT.MATERIAL_TYPE.HTML"
                  scrolling="no"
                  frameborder="0"
                  allowfullscreen="true"
                  :style="
                    `margin:0 auto;border: none !important;
                    overflow: hidden !important;
                    display: block;
                    background-color: black !important; 
                    width: 320px !important; height: 480px !important;`
                  "
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <img
      src="https://cdn.aralego.net/rich_media/assets/parallaxScrolling/bg2.png"
      style="width: 100%"
    />
  </div>
</template>

<script>
import mixPreview from '@/components/mixins/preview.js';
import mixMobile from '@/components/mixins/mobile.js';
import mixOutstream from '@/components/mixins/outstream.js';
import mixYoutubePlayer from '@/components/mixins/youtubePlayer.js';
import FacebookPlayer from '@/components/mixins/facebookPlayer.js';
export default {
  data() {
    return {
      index: 0,
      len: this.creative.images.length,
      h: 480,
      w: 320,
      video_h: this.creative.video_height,
      video_w: this.creative.video_width,
      vertical_padding: this.creative.vertical_padding,
      horizontal_padding: this.creative.horizontal_padding,
      player: null,
    };
  },
  computed: {
    position() {
      let layoutObj = this.setLayout(
        this.creative.vertical_align,
        this.vertical_padding,
        this.creative.horizontal_align,
        this.horizontal_padding
      );
      layoutObj.position = 'absolute';
      layoutObj['z-index'] = 1000;
      return layoutObj;
    },
    isamnet() {
      let domain = window.location.hostname;
      let isAmnet = 'https://cdn.aralego.net/rich_media/assets';
      if (domain === 'prism.amnet.tw') {
        isAmnet += '/amnet/bg.png';
      } else {
        isAmnet += '/parallaxScrolling/bg1.png';
      }
      return isAmnet;
    },
  },
  async mounted() {
    this.viewport();
    await this.$nextTick();
    setTimeout(() => {
      const content = document.querySelector('#ucf-content');
      const items = document.querySelectorAll(`.item`);

      if (this.creative.use_fullscreen && this.isMobile) {
        const vw =
            window.innerWidth ||
            window.document.documentElement.clientWidth ||
            window.document.body.clientWidth,
          ratio = vw / 320;
        this.w = vw;
        this.h = Math.round(this.h * ratio);
        this.video_w = Math.round(this.video_w * ratio);
        this.video_h = Math.round(this.video_h * ratio);
        this.vertical_padding = Math.round(this.vertical_padding * ratio);
        this.horizontal_padding = Math.round(this.horizontal_padding * ratio);
      }
      this.setStyle(content, {
        height: this.h + 'px',
        width: this.w + 'px',
      });
      items.forEach((item, index) => {
        this.setStyle(item, {
          width: this.w + 'px',
        });
      });

      if (this.creative.vast_xml) {
        this.creative.vast_xml = this.removeTrackingEvent(
          this.creative.vast_xml
        );
        const target = document.querySelectorAll('.item')[
          this.creative.video_index
        ];
        this.addPlayer(target, this.video_w, this.video_h);
        this.setStyle(this.video_div, this.position);
      } else if (this.creative.youtube_video_id) {
        let tag = document.createElement('script');
        tag.src = 'https://www.youtube.com/iframe_api';
        let firstScriptTag = document.getElementsByTagName('script')[0];
        firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);
        const target = document.querySelectorAll('.item')[
          this.creative.video_index
        ];
        window.onYouTubeIframeAPIReady = () => {
          const videoId = this.creative.youtube_video_id;
          this.player = this.addYtPlayer(
            target,
            videoId,
            this.video_w.toString(),
            this.video_h.toString()
          );
          this.video_div.removeAttribute('style');
          this.setStyle(this.video_div, this.position);
        };
      } else if (this.creative.facebook_video_url) {
        const fbStream = new FacebookPlayer(
          this.creative.facebook_video_url,
          this.creative.video_width,
          this.creative.video_height,
          this.creative.facebook_video_landing_page
        );
        const fbStreamEle = fbStream.init();
        this.setStyle(fbStreamEle, this.position);
        const fbTarget = document.querySelectorAll('.item')[
          this.creative.video_index
        ];
        fbTarget.appendChild(fbStreamEle);
      }

      this.scroll();
      this.addEvent(window, 'scroll', this.scroll);
      if (this.len > 1) {
        const wrapper = document.querySelector('.ucf-carousel-wrapper');
        const container = document.querySelector('.ucf-carousel-container');
        this.right = () => this.handleGesture('right');
        this.left = () => this.handleGesture('left');
        this.handleTouch(wrapper);
        this.handleAnimate(container);

        let tmp = items[0].cloneNode();
        tmp.style.transform = `translateX(${this.len * 100}%)`;
        tmp.className = 'tmp-item';
        let material_type = this.creative.images[0].material_type;
        if (material_type === CONSTANT.MATERIAL_TYPE.IMAGES) {
          let tmp_img = document.createElement('img');
          tmp_img.src = this.creative.images[0].url;
          tmp_img.style.width = '100%';
          tmp.appendChild(tmp_img);
        }
        if (material_type === CONSTANT.MATERIAL_TYPE.HTML) {
          let tmp_iframe = document.createElement('iframe');
          tmp_iframe.src = this.creative.images[0].url;
          tmp_iframe.style.width = '100%';
          tmp.appendChild(tmp_iframe);
        }
        if (this.creative.vast_xml && this.creative.video_index === 0) {
          let tmp_video = document.createElement('div');
          this.setStyle(tmp_video, {
            width: this.video_w + 'px',
            height: this.video_h + 'px',
            'background-color': 'black',
          });
          this.setStyle(tmp_video, this.position);
          tmp.appendChild(tmp_video);
        }
        if (this.creative.youtube_video_id && this.creative.video_index === 0) {
          let tmp_video = document.createElement('div');
          this.setStyle(tmp_video, {
            width: this.video_w + 'px',
            height: this.video_h + 'px',
            'background-color': 'black',
          });
          this.setStyle(tmp_video, this.position);
          tmp.appendChild(tmp_video);
        }
        container.appendChild(tmp);
        let marqueeIO = new IntersectionObserver(
          (entries) => {
            if (entries[0].isIntersecting) {
              this.isAnimating = true;
              setTimeout(() => {
                this.setStyle(container, {
                  width: this.len * 100 + '%',
                  animation: `marquee 1s linear`,
                });
              }, 500);
              setTimeout(() => {
                tmp.remove();
                items.forEach((item, index) => {
                  if (index !== this.index) {
                    item.classList.add('hide');
                    setTimeout(() => item.classList.remove('hide'), 100);
                  }
                  item.style.transform =
                    index === this.len - 1 && this.len > 2
                      ? 'translateX(-100%)'
                      : `translateX(${index * 100}%)`;
                });
                this.isAnimating = false;
                marqueeIO.unobserve(wrapper);
                if (this.creative.vast_xml) {
                  this.videoIO.observe(this.video_div);
                }
              }, 2000);
            }
          },
          { threshold: 0.5 }
        );
        marqueeIO.observe(wrapper);
      }
    }, 200);
    this.creative.images.forEach((image, index) => {
      let millisecond = image.millisecond;
      if (image.material_type === CONSTANT.MATERIAL_TYPE.HTML && millisecond) {
        let times = image.times;
        if (times > 0) {
          times = times - 1;
        }
        let timer = setInterval(() => {
          if (times !== 0) {
            let h5 = document.querySelector(`.h5-${index}`);
            h5.src = h5.src;
          } else {
            clearInterval(timer);
          }
          if (times !== -1) {
            times = times - 1;
          }
        }, millisecond);
      }
    });
  },
  mixins: [mixPreview, mixMobile, mixOutstream, mixYoutubePlayer],
  methods: {
    handleGesture(gesture) {
      if (this.isAnimating) return;
      gesture === 'left' ? this.shift() : this.invert_shift();
    },
    scroll() {
      const target = document.querySelector('#ucf-content');
      const wrapper = document.querySelector('#main-wrapper');
      const container = document.querySelector('#main-container');
      let vw =
          window.innerWidth ||
          window.document.documentElement.clientWidth ||
          window.document.body.clientWidth,
        w = this.w,
        vh =
          window.innerHeight ||
          window.document.documentElement.clientHeight ||
          window.document.body.clientHeight,
        h = this.h,
        div_top = this.offsets(target),
        div_bottom = div_top + h,
        scroll_top =
          window.document.scrollingElement.scrollTop ||
          window.document.documentElement.scrollTop ||
          window.document.body.scrollTop,
        scroll_bottom = scroll_top + vh,
        x = h,
        styleObj = {
          position: 'absolute',
          top: '0',
          bottom: '0',
        };

      if (scroll_bottom < div_bottom) {
        x = scroll_bottom - div_top;
        styleObj = {
          position: 'fixed',
          top: 'auto',
          bottom: h - x + 'px',
        };
      } else if (scroll_top > div_top) {
        x = div_bottom - scroll_top;
        styleObj = {
          position: 'fixed',
          top: h - x + 'px',
          bottom: 'auto',
        };
      }

      x = x < 0 ? 0 : x;

      this.setStyle(wrapper, styleObj);
      this.setStyle(container, { height: x + 'px' });
    },
    shift() {
      if (this.index === this.creative.video_index) {
        if (this.creative.vast_xml) {
          this.onVideoPause();
        }
        if (this.creative.youtube_video_id) {
          this.player.pauseVideo();
        }
      }
      const next_index = (this.index + 1) % this.len;
      const items = document.querySelectorAll(`.item`);
      let x;

      if (this.len > 2) {
        items.forEach((item, index) => {
          x = index - next_index;
          if (Math.abs(x) === this.len - 1) {
            x = this.len - 2 > 1 ? -x % (this.len - 2) : -x / 2;
          }
          if (index !== this.index && index !== next_index) {
            item.classList.add('hide');
            setTimeout(() => item.classList.remove('hide'), 500);
          }
          item.style.transform = `translateX(${x * 100}%)`;
        });
      } else {
        x = this.index - next_index;
        items[this.index].style.transform = `translateX(${x * 100}%)`;
        items[next_index].style.transform = `translateX(0%)`;
      }
      if (next_index === this.creative.video_index) {
        if (this.creative.vast_xml) {
          setTimeout(this.onVideoPlay, 1500);
        }
        if (this.creative.youtube_video_id) {
          setTimeout(() => this.player.playVideo(), 1500);
        }
      }
      this.index = next_index;
    },
    invert_shift() {
      if (this.index === this.creative.video_index) {
        if (this.creative.vast_xml) {
          this.onVideoPause();
        }
        if (this.creative.youtube_video_id) {
          this.player.pauseVideo();
        }
      }
      const next_index = (this.len + this.index - 1) % this.len;
      const items = document.querySelectorAll(`.item`);
      let x;

      if (this.len > 2) {
        items.forEach((item, index) => {
          x = index - next_index;
          if (Math.abs(x) === this.len - 1) {
            x = this.len - 2 > 1 ? -x % (this.len - 2) : -x / 2;
          }
          if (index !== this.index && index !== next_index) {
            item.classList.add('hide');
            setTimeout(() => item.classList.remove('hide'), 500);
          }
          item.style.transform = `translateX(${x * 100}%)`;
        });
      } else {
        x = this.index - next_index;
        items[this.index].style.transform = `translateX(${x * 100}%)`;
        items[next_index].style.transform = `translateX(0%)`;
      }

      if (next_index === this.creative.video_index) {
        if (this.creative.vast_xml) {
          setTimeout(this.onVideoPlay, 1500);
        }
        if (this.creative.youtube_video_id) {
          setTimeout(() => this.player.playVideo(), 1500);
        }
      }
      this.index = next_index;
    },
    messageHandler(e) {
      const frame = document.querySelector('iframe');
      switch (e.data.type) {
        case 'close':
          frame.style.display = 'none';
          break;
        case 'ready':
          this.setPlayerConfig();
          this.initialAd(this.creative.vast_xml);
          if (this.len == 1) this.videoIO.observe(this.video_div);
          break;
        case 'Loaded':
          frame.style.display = 'block';
          this.onVideoPlay();
          this.removeVideoClickDiv();
          break;
        case 'Start':
          this.showToolBar();
          break;
        case 'error':
          this.$notify.error({
            title: 'Error',
            message: e.data.error,
            position: 'bottom-right',
            offset: 20,
          });
        default:
          break;
      }
    },
    openLandingPage() {
      window.open(this.creative.landing_page, '_blank');
    },
  },
};
</script>
<style lang="sass" scoped>
#ucf-content
  border: medium none
  overflow: hidden
  transform-origin: 0px 0px 0px
  transform: translateZ(0px)
  margin: auto
  #main-wrapper
    position: absolute
    width: 100%
    height: 100% !important
    max-height: none !important
    transform: translateZ(0)
    -webkit-transform: translateZ(0)
    #main-container
      .ucf-carousel-wrapper
        cursor: pointer
        overflow-x: hidden
        height: 100%
        .arrow
          border: none
          outline: 0
          padding: 0
          margin: 0
          top: 50%
          height: 50px
          width: 50px
          cursor: pointer
          position: absolute
          z-index: 999
          background-repeat: no-repeat
          background-size: 12px 30px
          -webkit-tap-highlight-color: rgba(0, 0, 0, 0)
          animation: fade 1s infinite alternate
          &-left
            background-image: url('https://cdn.aralego.net/rich_media/assets/left_btn.png')
            background-position: left center
            left: 0px
          &-right
            background-image: url('https://cdn.aralego.net/rich_media/assets/right_btn.png')
            background-position: right center
            right: 0px
        .ucf-carousel-container
          height: 100%
          .item, .tmp-item
            position: absolute
            display: inline-block
            overflow: hidden
            height: 100% !important
            max-height: none !important
            top: 0
            z-index: 0
            transition: transform 0.5s ease-in-out
            img
              width: 100% !important
              max-width: none !important
            &.hide
              display: none
            .overlay-iframe
              position: absolute
              width: 320px
              height: 480px
              z-index: 100
              top: 0
              left: 0


@include keyframes(fade)
  0%
    opacity: 0
  100%
    opacity: 1

@include keyframes(marquee)
  0%
    transform: translateX(0%)
  100%
    transform: translateX(-100%)
</style>
